import {useEffect, useState} from 'react'
import {BasicLayout} from './Layouts/basicLayout'
import './CategoriesClient.css'
// import axios from 'axios'
import {parentCategories} from '../interfaces/categories'
import {useHistory} from 'react-router-dom'
import {useGlobalContent} from '../context/helpersProvider'
// import expiredToken from '../utils/headerAuth'

export const CategoriesClient = () => {
  interface parentCategoriesInterface extends Array<parentCategories> {}

  const [flag, setFlag] = useState(false)
  // const {setShowToast} = useGlobalContent()
  // const [AllCategories, setAllCategories] = useState<parentCategoriesInterface>()
  const history = useHistory()

  // const getData = async () => {
  //   let sessionId = localStorage.getItem('idClient')
  //   let tempUserCategories: any = []
  //   let tempAvailable: any = []

  //   try {
  //     const userCategoriesResponse = await axios.get(
  //       `/category/find/${sessionId !== null && JSON.parse(sessionId)}`
  //     )
  //     const availableCategoriesResponse = await axios.get(
  //       `/category/get/${sessionId !== null && JSON.parse(sessionId)}`
  //     )

  //     // Asignamos un atributo si es que el usuario tiene esa categoría
  //     userCategoriesResponse.data.data?.forEach((l: any) => {
  //       l.sub_categories.forEach((sub: any) => (sub.isCategoryUser = true))
  //     })
  //     tempUserCategories = userCategoriesResponse.data.data

  //     // Asignamos un atributo si es que el usuario tiene esa categoría
  //     availableCategoriesResponse.data.data?.forEach((l: any) => {
  //       l.sub_categories.forEach((sub: any) => (sub.isCategoryUser = false))
  //     })
  //     tempAvailable = availableCategoriesResponse.data.data

  //     let arr: any = []

  //     // Después de asignar el atributo, unimos los dos arreglos
  //     tempAvailable?.forEach((l: any) => arr.push(l))
  //     tempUserCategories?.forEach((l: any) => {
  //       let index = arr.findIndex((e: any) => e.id === l.id)
  //       if (index !== -1) {
  //         arr[index].sub_categories = [...arr[index].sub_categories, ...l.sub_categories]
  //       } else {
  //         arr.push(l)
  //       }
  //     })

  //     // Ordenamos las subcategorías de acuerdo al orden específico
  //     arr.forEach((l: any) => {
  //       l.sub_categories.sort((a: any, b: any) => {
  //         const order = ['Macroeconomics', 'Sovereign', 'Corporates']
  //         return order.indexOf(a.name) - order.indexOf(b.name)
  //       })
  //     })

  //     setAllCategories(arr)
  //   } catch (error) {
  //     expiredToken(history, error, setShowToast)
  //   }
  // }

  useEffect(() => {
    if (localStorage.getItem('idClient') !== null) {
      // getData()
    } else {
      history.push('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flag])

  // const handleSelector = (e: any) => {
  //   const {value} = e.target
  //   let temp = [...AllCategories!]
  //   temp.forEach((l: any) => {
  //     let index = l.sub_categories.findIndex((e: any) => e.id === parseInt(value))
  //     if (index !== -1) {
  //       l.sub_categories[index].isCategoryUser = !l.sub_categories[index].isCategoryUser
  //     }
  //   })
  //   setAllCategories(temp)
  // }

  // const saveCategories = (e: any) => {
  //   let temp = [...AllCategories!]
  //   //solo obtenemos el id int de las categorias que el usuario selecciono
  //   let arrAgregarCategories: any = []
  //   let arrEliminarCategories: any = []
  //   temp.forEach((l: any) => {
  //     l.sub_categories.forEach((sub: any) => {
  //       if (sub.isCategoryUser) {
  //         arrAgregarCategories.push(sub.id)
  //       } else {
  //         arrEliminarCategories.push(sub.id)
  //       }
  //     })
  //   })
  //   //verificamos que el usuario tenga cero categorias disponibles para agregar y si se cumple se agrega un id -1
  //   //que indica que el usuario tiene todas las categorias seleccionadas
  //   if (arrEliminarCategories.length === 0) {
  //     arrAgregarCategories.push(-1)
  //   } else {
  //     arrEliminarCategories.push(-1)
  //   }
  //   let sessionId = localStorage.getItem('idClient')

  //   if (arrAgregarCategories?.length > 0) {
  //     //eliminamos las categorias que el usuario no quiere, se recorre la lista porque en el backend se elimina una por una
  //     arrEliminarCategories.forEach((value: any) =>
  //       axios
  //         .post('/category/remove', {
  //           userId: parseInt(sessionId !== null && JSON.parse(sessionId)),
  //           category: value,
  //         })
  //         .then((json) => json.data)
  //     )

  //     axios
  //       .post('/category', {
  //         userId: parseInt(sessionId !== null && JSON.parse(sessionId)),
  //         categories: arrAgregarCategories,
  //       })
  //       .then((json) => json.data)
  //       .then((datos) => {
  //         if (datos.status === 200) {
  //           // history.push({pathname: '/home'})
  //           setShowToast({
  //             open: 'true',
  //             message: 'Categories updated successfully',
  //             type: 'success',
  //           })
  //         }
  //       })
  //   } else {
  //     setShowToast({
  //       open: 'true',
  //       message: 'Please select at least one category',
  //       type: 'error',
  //     })
  //   }
  // }

  // const handleAll = (e: any) => {
  //   let temp = [...AllCategories!]
  //   temp.forEach((l: any) => {
  //     l.sub_categories.forEach((sub: any) => {
  //       sub.isCategoryUser = true
  //     })
  //   })
  //   setAllCategories(temp)
  // }

  return (
    <BasicLayout>
      <div className='content-div'>
        <h4 className='h3-title' style={{display: 'flex', alignItems: 'center'}}>
          <button onClick={() => history.goBack()} className='back-button w-button' />
          &nbsp;&nbsp;&nbsp;Email Subscription Preferences
        </h4>
        {/* <div className='separador'></div>
        <div className='w-form'></div>

        <div style={{width: '100%', textAlign: 'center'}}>
          <button
            onClick={handleAll}
            className='tag'
            value={-1}
            style={{paddingLeft: '30px', paddingRight: '30px',paddingTop:'17px',paddingBottom:'17px'}}
          >
            All Categories
          </button>
        </div>
        <div className='w-row'>
          {AllCategories?.map((category) => (
            <div key={category.id} className='w-col w-col-4'>
              <h5 className='categorie'>{category.name}</h5>
              <div className='tag-list'>
                {category.sub_categories.map((sub) => (
                  <button
                    key={sub.id}
                    onClick={handleSelector}
                    className={sub.isCategoryUser ? 'selected' : 'tag'}
                    value={sub.id}
                  >
                    {sub.name}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className='separador'></div>
        <div className='btns-div'>
          <button onClick={saveCategories} className='short-btn save w-button'>
            Save
          </button>
        </div> */}
      </div>
    </BasicLayout>
  )
}
